module.exports = __webpack_public_path__ + "static/media/direction-left.32715e18.svg";